// Pattern modale Wizard SERME (saisie complexe : creation livraison, edit
// site, creation BSD, creation materiel, confirmation vehicule, etc.).
// Header colore bandeau + body gris leger + footer gris + croix blanche
// visible. `gap-0` evite que le `gap-4` shadcn revele bg-background entre
// header/body/footer.

/** Classes de base a appliquer au DialogContent. A combiner avec un max-w-* via cn(). */
export const WIZARD_DIALOG_CONTENT_BASE =
  'p-0 gap-0 overflow-hidden flex flex-col max-h-[85vh]';

/** Header sombre type "site enlevement / creation materiel / creation BSD". */
export const WIZARD_DIALOG_HEADER_NAVY =
  'bg-surface-header text-surface-header-foreground px-6 py-4 space-y-1 shrink-0';

/** Header sombre type "site exutoire / destination SERME" — token `site-exutoire`. */
export const WIZARD_DIALOG_HEADER_EXUTOIRE =
  'bg-site-exutoire text-white px-6 py-4 space-y-1 shrink-0';

/** Body de modale wizard : padding standard, scroll vertical, fond gris leger
 *  qui fait ressortir les cartes blanches internes. */
export const WIZARD_DIALOG_BODY =
  'px-6 py-5 overflow-y-auto flex-1 bg-muted/40';

/** Footer separe du body par une bordure, fond gris coherent avec le body. */
export const WIZARD_DIALOG_FOOTER =
  'border-t border-border bg-muted px-6 py-4 shrink-0';

/** A passer en prop `closeClassName` du DialogContent des qu'on a un header
 *  bandeau sombre, sinon la croix par defaut est invisible. */
export const DARK_HEADER_CLOSE =
  'text-surface-header-foreground/70 hover:text-surface-header-foreground hover:bg-surface-header-foreground/10';

/** Titre principal d'un DialogHeader sombre. */
export const WIZARD_DIALOG_TITLE =
  'text-2xl font-bold uppercase tracking-tighter';

/** Sous-titre/description dans un DialogHeader sombre. text-white/70 plutot
 *  que text-muted-foreground qui est illisible sur fond navy. */
export const WIZARD_DIALOG_DESCRIPTION =
  'text-[11px] font-bold text-surface-header-foreground/70 uppercase tracking-widest';
